import { Navigate } from "react-router-dom";
import { useAuth } from "../00-CONTEXT/AuthContext"; // Import du contexte Auth

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth(); // Utilisation du contexte Auth

  if (loading) {
    // Afficher un indicateur de chargement pendant la vérification
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Si non authentifié, redirige vers /login
    return <Navigate to="/login" />;
  }

  // Si authentifié, afficher les enfants
  return children;
}

export default ProtectedRoute;